export default __webpack_public_path__ + "static/logo@2x-reverse-d3a8900264d035bb825f93f054258c59.png";